<template>
  <div
    class="contract-job-tracking flex flex-col justify-between w-full md:pt-8"
  >
    <template v-if="scopeItems">
      <div
        class="scope-group"
        :key="`scope_group_${i}`"
        v-for="(doc, i) in scopeItems"
      >
        <h2>{{ doc.name || "Unnamed Scope Document" }}</h2>

        <collapsible-scope-item
          :scope-item="scopeItem"
          :key="`scope_item_${i}`"
          v-for="(scopeItem, i) in doc.work_scope_items"
        />
      </div>
    </template>
    <div class="empty-state" v-else>
      No data to show.
    </div>
  </div>
</template>

<script>
import CollapsibleScopeItem from "../../components/contract/CollapsibleScopeItem";
import ScopeItemForm from "@/views/contracts/forms/ScopeItemForm";
import { mapGetters } from "vuex";

export default {
  name: "ContractJobTracking",
  components: {
    CollapsibleScopeItem
  },
  data() {
    return {
      contractId: parseInt(this.$route.params.id, 10)
    };
  },
  computed: {
    ...mapGetters(["jobTrackingItems"]),

    scopeItems() {
      let self = this;
      if (self.jobTrackingItems) {
        self.jobTrackingItems.map(item => {
          item.work_scope_items.map(scope_item => {
            scope_item.actions = [
              {
                label: "edit",
                clickAction: item => {
                  this.$store.commit("setCreateEditComponentParams", {
                    createEditComponent: ScopeItemForm,
                    createEditComponentData: {
                      ...item,
                      scopeItemName: scope_item.name,
                      work_scope_id: scope_item.work_scope_id,
                      work_scope_work_scope_item_id: scope_item.pivot.id
                    },
                    createEditComponentIsShown: true
                  });
                }
              }
            ];
          });
        });
        //console.log(self.jobTrackingItems)
        return self.jobTrackingItems;
      } else {
        return false;
      }
    }
  },
  created() {
    this.$store.dispatch("getContractScopeItems", {
      contractId: this.contractId
    });
  }
};
</script>

<style lang="scss" scoped>
.contract-job-tracking {
  .scope-group {
    &:not(:first-child) {
      @apply mt-4;
    }
  }
}
</style>
